module.exports = __webpack_public_path__ + "img/14.3-gallery.5cf28e6a.jpg";